interface ShadowSummaryData {
	state: unknown
	metadata: string
}

interface ShadowSummaryPanelProps {
	shadowSummary: Record<string, ShadowSummaryData>
}

export const ShadowSummaryPanel = ({shadowSummary}: ShadowSummaryPanelProps) => (
	<div className="mb-4">
		<h4 className="font-medium text-gray-700 dark:text-gray-300 mb-2">Shadow Summary:</h4>
		<div className="grid grid-cols-1 gap-2">
			{Object.entries(shadowSummary).map(([shadowType, data]) => (
				<div key={shadowType} className="bg-gray-50 dark:bg-gray-700/50 p-2 rounded text-sm">
					<div className="font-medium text-gray-600 dark:text-gray-300 capitalize">
						{shadowType} Shadow:
					</div>
					<div className="text-xs text-gray-500 dark:text-gray-400 mt-1">
						State: {typeof data.state === "object" ? "Object with data" : String(data.state)}
					</div>
					<div className="text-xs text-gray-500 dark:text-gray-400">Metadata: {data.metadata}</div>
				</div>
			))}
		</div>
	</div>
)
